/// /////////////////////////////////////////////////////////////////////////
///     REMINDER                                                         ///
///   * search for text in the file before adding it *                   ///
/// /////////////////////////////////////////////////////////////////////////

export default {
  translation: {
    mah: "MAH",
    hcs: "HCs",

    sce: "SCE",
    tag: "TAG",
    wo: "WO",
    cto: "CTO",
    moc: "MOC",
    eps: "EPS",
    mahs: "MAHs",
    sces: "SCEs",
    csgs: "CSGs",
    tags: "TAGs",
    ctos: "CTOs",
    wos: "WOs",
    barriers: "Barriers",

    bowtie: "Bowtie",
    workOrder: "Work Order",
    workOrders: "Work Orders",
    caseToOperate: "Case to Operate",
    requestsManager: "Requests Manager",
    userPermissions: "User Permissions",
    maintType: "Maint. Type",
    tagOrSce: "TAG or SCE",
    tagAndWo: "TAG and WO",

    home: "Home",
    facilities: "Facilities",
    jobCode: "Job Code",
    signOut: "Sign out",
    signIn: "Sign in",
    hi: "Hi, {{name}}",
    vessels: "Vessels",

    affectedMah: "Affected MAH", //REFACTOR: use affectedMah or mahAffected
    affectedHc: "Affected HC",
    mahAffected: "MAHs affected",
    mahAffectedEps: "Linked MAHs  (no effect on MAH health status)",

    generic: {
      loading: "Loading...",
      status: "Status",
      remove: "Remove",
      updatingStatus: "Updating status",

      comments: "Comments",
      commentsWithColon: "Comments:",

      commentWithField: "Comment {{field}}",
      optional: " (optional)",
      mandatory: " (mandatory)",

      dueDate: "Due Date",
      exportTo: "Export to",

      review: "Review",
      reviewed: "REVIEWED",
      editReview: "EDIT REVIEW",
      pendingReview: "PENDING REVIEW",

      justification: "Justification",
      justificationWithColon: "Justification:",
      justificationWithField: "Justification {{field}}",

      approvedBy: "Approved by",
      approve: "Approve",
      reject: "Reject",

      description: "Description",
      recommendation: "Recommendation",

      find: "Find {{field}}",
      typeField: "Type a {{field}}",
      typeHere: "Type here...",
      search: "Type here to search...",
      searchButtonLabel: "Search",
      selectAnOption: "Select an option",

      affected: "Affected {{field}}",

      linked: "Linked {{field}}",
      linkedOn: "Linked {{linkedField}} on {{linkedFrom}}",

      fieldCode: "{{field}} code",
      fieldStatus: "{{field}} status",
      fieldNo: "{{field}} No.",

      tagType: "TAG Type",
      mahsAndBarriers: "MAHs - Barriers",
      hcsAndBarriers: "HCs - Barriers",
      mahsAndBarriersModalTitle: "Linked MAHs and Barriers",
      hcsAndBarriersModalTitle: "Linked HCs and Barriers",
    },

    formGeneric: {
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      update: "Update",
      close: "Close",

      // saves
      confirm: "Confirm",

      submitForm: "Submit Form",
      submitting: "Submitting...",

      save: "Save",
      saving: "Saving...",
      saveDraft: "Save Draft",

      send: "Send",
      sending: "Sending...",

      add: "Add",
      adding: "Adding...",
      addComments: "Add comments",
      addMember: "Add Member",
      addAnother: "Add another",
      addMoreTeamMember: "ADD MORE TEAM MEMBER",
      addMoreTeamMemberEps: "Add Team Member",

      all: "All",
      seeAll: "See all",
      seeDetails: "SEE DETAILS",
      seeComments: "See comments",
      seeRequests: "See requests",
      collapseAll: "Collapse all",
      expandAll: "Expand all",
      select: "Select",
      selectAll: "Select all",
      clearAll: "Clear all",

      //fields
      ok: "OK",
      yes: "Yes",
      no: "No",
      onGoing: "On going",
      accept: "Yes (Accept)",
      reject: "No (Reject)",
      rejected: "REJECTED",
      rejectedBy: "REJECTED BY",
      mandatory: "(Mandatory)",
      unknownLabel: "Unknown",
      notApplication: "Not applicable",

      typeHereMandatory: "Type here (mandatory)...",
      typeNameOrEmail: "Type name or e-mail...",

      nameOrEmail: "Name or e-mail",
      name: "Name",
      email: "E-mail",
      position: "Position",
      applySelected: "Apply selected",
      vessels: "Vessels",
      actions: "Actions",

      // alert
      requiredField: "This field is required",
      requiredAtLeastOneItem: "At least 1 item is required",
      needYourInput: "Needs your input",
    },

    navigation: {
      close: "Close",
      next: "Next",
      back: "Back",
      goBack: "Go Back",
      finish: "Finish",
      return: "Return",
      goTo: "Go to {{field}}",
      goToFull: "Go to full {{field}}",
      goBackToFacilities: " Go back to facilities",
      confirm: "Confirm",
    },

    status: {
      healthy: "Healthy",
      mitigated: "Mitigated",
      degraded: "Degraded",
      critical: "Critical",
      noInfo: "No Info",
      noStatusProcedural: "No status (Procedural)",
      affected: "Affected",
      notAffected: "Not Affected",
      low: "LOW:",
      medium: "MEDIUM:",
      high: "HIGH:",
      lowPriority: "Low Priority (doesn't affect safety functions)",
      highPriority: "High Priority (affects safety functions)",
    },

    controlStatus: {
      ON_GOING: "On going",
      LAST_WEEK: "Expiring in one week",
      OVERDUE: "Overdue",
      COMPLETED: "Completed",
      tooltip: {
        ON_GOING: "More than 7 days remain until the due date.",
        LAST_WEEK: "7 days or less remaining until the due date.",
        OVERDUE: "The due date has passed.",
        COMPLETED: "The recommendation is completed",
      },
    },

    ctoStatus: {
      underEvaluation: "Under Evaluation",
      live: "Live",
      extensionRequired: "Extension Required",
      completed: "Completed",
      cancelled: "Cancelled",
      expired: "Expired",
      UNDER_EVALUATION: "Under Evaluation",
      LIVE: "Live",
      EXTENSION_REQUIRED: "Extension Required",
      COMPLETED: "Completed",
      CANCELLED: "Cancelled",
      CLOSED: "Cancelled",
      EXPIRED: "Expired",
      finished: "Completed, Expired or Cancelled",
      activated: "ACTIVATED",
      underEvaluationUpperCase: "UNDER EVALUATION",
      tooltip: {
        UNDER_EVALUATION: "Under Evaluation",
        LIVE: "Live",
        EXTENSION_REQUIRED: "Extension Required",
        COMPLETED: "Completed",
        CANCELLED: "Cancelled",
        CLOSED: "Cancelled",
        EXPIRED: "Expired",
      },
    },

    feedback: {
      formSentSuccessfully: "Form sent successfully!",
      success: "Success!",
      error: "Error",
      warning: "Warning",
      important: "Important",
      yourActionWasNotProcessed:
        "Your action was not processed by the system. Please try again",
      areYouSure: "Are you sure you want to continue?",
      iAmAware: "I am aware",
      deleted: "Successfully deleted.",
      errorReloadPage: "Error, click here to reload the page.",
      attention: "Attention",
    },

    genericComponents: {
      noData: "No items to show",
      by: "by",

      information: "Information",
      implementation: "Implementation",
      implementationAction: "Implementation Action",
      reAssessment: "Re-assessment Attachments",
      mitigation: "Mitigation Action Attachments",
      filter: {
        title: "Filters",
        clear: "Clear filter",
        clearCont: "Clear filters ({{count}})",
        noData: "No data to filter",
      },
      file: {
        label: "Attach file",
        attach: "Attach",
        attachments: "Attachments",
        attachmentsImplementation: "Attachments Implementation",
        successfullyAttached: "successfully attached to",
        processingFile:
          "Processing file(s), please try submitting again in a moment...",
        clickToUpload: "Click to Upload",
        orDragAndDrop: "or drag and drop",
        maxFileSize: "Max. File size: {{maxFileSize}}MB",
        maxFileNum: "Max. Number of files per submission: {{maxFileNum}}",
        uploading: "Uploading",
        completed: "Completed",
        error: {
          boxTitle: "Number of files exceeded",
          boxText: "Max Number of files: {{maxFilesNum}}",
          sizeExceeded: "File is too large. Max size is {{maxFileSize}}",
          unsupported: "Unsupported file type",
        },
        uploadFileSuccess: "File successfully attached!",
      },
      multipleSelect: {
        noData: "No options to select",
      },
      selectWithFilter: {
        chooseFromList: "Choose from list...",
        chooseItemName: "Choose a {{itemName}} or type to filter...",
        typeToFind: "Type to find an item...",
        chooseItemTypeToFilter: "Choose an item or type to filter...",
      },
      recommendationComplete: "Is the recommendation implemented?",
      isPermanentChange: "Is the recommendation permanent?",
      maxLength: "The maximum length is {{maxChars}} characters",
    },

    breadcrumbs: {
      BR: "Brazil",
      MEXICO: "Mexico",
      facilities: "Facilities",
      info: "Info",
      bowtie: "Bowtie",
      "support-requests": "Support Requests",
      "case-to-operate": "Case To Operate",
      "cto-list": "CTO LIST",
      dashboard: "Dashboard",
      "work-orders": "Work Orders",
      matrix: "Matrix View",
      sces: "SCEs",
      mahs: "MAHs",
      tagsAndWorkOrders: "Tags and Work Orders",
      "mahs-by-sce": "MAHs by SCE",
      SOUTH_AMERICA: "South America",
      NORTH_AMERICA: "North America",
      WEST_AFRICA: "West Africa",
      NORTH_SEA: "North SEA",
      SOUTHEAST_ASIA: "South Asia",
      SENEGAL: "Senegal",
      OCEANIA: "Oceania",
    },

    filterBoxTooltip: {
      woClassification: "Work Order Classification",
      tagClassification: "TAG Classification",
      sceClassification: "SCE Classification",

      correctiveWoWithPriorities: "Corrective WO's, with 0, 1 or 2 priorities.",
      correctiveWoWithPrioritiesOther:
        "Corrective WO's, with priorities other than 0, 1 or 2, Overdue preventive WO's",

      preventiveWoOnTime: "Preventive WO's on time.",

      correctiveWoWithEffect3: "Corrective WO's with effect 3.",
      correctiveWoWithEffect2:
        "Corrective WO's with effect 2, Overdue preventive WO's",
      correctiveWoWithEffect1:
        "Corrective WO's with effect 1, Preventive WO's on time.",

      atLeastOneCriticalWO: "At least 1 critical WO",
      atLeastOneCriticalTAG: "At least 1 critical TAG",
      thereAreNoCriticalWo:
        "There are no critical WO and at least 1 degraded WO",
      thereAreNoCriticalTAG:
        "There are no critical TAG and at least 1 degraded TAG",

      allOfWoAreHealthy: "There are no WO or all of WO are healthy",
      allOfTagAreHealthy: "All of TAG are healthy",
      tagMitigated:
        "The TAG has an active mitigation measure. The TAG will return to its previous status once the CTO is closed.",
      sceMitigated:
        "The SCE has associated TAGs with an active mitigation measure. The SCE will return to its previous status once the CTO is closed.",
    },

    lastUpdate: {
      title: "Last update on",
      at: "at",
      error: "Last update unavailable",
    },

    errorPage: {
      title: "Seems like something went wrong...",
      mainText:
        "The page you requested does not exist, or you do not have permission to access it. Try to reload it or go back to the Reef homepage.",
      genericErrorText:
        "Try to refresh it or go back to the Reef homepage. If the error continues, contact the Customer Support. ",
      modalEmpty: "The model cannot be built due to missing components",
    },

    isConstructionAlert: {
      underConstructionMessage:
        "This section is currently under development and may contain placeholder information",
    },

    noDataInfo: {
      facilities:
        "Could not load Facilities screen, please try again later. If the error continues, contact the Customer Support.",
      notLoadField: "Could not load {{field}}, please try again later",
    },

    topBar: {
      barrierManagementSystem: "Barrier Management System",
      digital: "Digital",
      poweredBy: "powered by",
    },

    permissionPage: {
      addNewUser: "Add New User",
      newUserGroup: "New User Group",
      userGroups: "User Groups",
      userGroupManagement: "User Group Management",
      accessRightsList: "Access Rights List",
      delete: {
        deleteUserGroup: "Delete user group",
        successfullyDeleted:
          "The new user group has been deleted successfully.",
        confirmUserGroupDeleteText: {
          firstHalf: "You are deleting the user group",
          secondHalf: ". Are you sure you want to proceed with the deletion?",
        },
        userGroupWithUsersText: {
          firstHalf: "You are attempting to delete the user group",
          secondHalf:
            ". Before deleting it, please change the user group of all users linked to this group.",
        },
      },
      form: {
        editUserGroup: "Editing user group",
        newUserGroup: "New User Group",
        userGroupName: "User Group Name",
        userGroupDetails: "User group details",
        userGroupHistory: "User group history",
        recommendedPosition: "Recommended position",
        confirmEditModalTitle: "Saving permissions changes in this user group",
        groupPermissionChangedBy: "Changed by {{email}} on {{date}}",
        groupPermissionCreatedBy: "Created by {{email}} on {{date}}",
        ctoPermission: "CTO Permission",
        confirmEditText:
          "Saving changes to a user group's permissions will affect all users in this group. Are you sure you want to save these changes?",
        success: {
          newUserGroup: "The new user group has been created successfully.",
          editUserGroup:
            "The changes to user group permissions have been successfully saved.",
        },
        warning: {
          positionHasGroup:
            "There is already a user group associated with this position, but this does not prevent a new user group from being related to this position.",
        },
        error: {
          userGroupAlreadyExists:
            "This user group name is already registered in the system and cannot be reused.",
          maxLength40: "The maximum length is 40 characters",
        },
      },
      table: {
        shortName: {
          userGroupName: "User Group Name",
          recommendedPosition: "Recommended Position",
          CTO_IDENTIFICATION: "Ident.",
          CTO_INITIATION: "Step 1",
          CTO_EVALUATION: "Step 2",
          CTO_REVIEW: "Step 3",
          CTO_APPROVAL: "Step 4",
          CTO_MITIGATION: "Step 5",
          CTO_REASSESSMENT: "Step 6",
          CTO_VERIFICATION: "Step 7",
          CTO_CLOSURE: "Step 8",
          CTO_EXTEND: "Extend",
          CTO_CLOSE: "Close",
          WO_CHANGE_STATUS: "WOs",
          REQUEST_MANAGEMENT: "Sup. Reqs.",
          USER_PERMISSION: "User Perm.",
          DELETE_VESSEL_CTO: "Delete",
        },
      },
      backButtonLabel: "Go back to the Access Rights List",
    },

    permissionLegend: {
      title: "Permissions by User Group",
      permissionDescription: "Permissions Description",
      vesselAdminLegend:
        "All fields should be enabled and it will have permission to modify user access only for their respective vessel(s).",
      processSafetyLegend:
        "This group will have access to CtO review, CtO Closure Verification, and Change WO status.",
      opsManagerLegend:
        "This group will have access to CtO Approval, CtO Closure Approval, and Change WO status.",
      shapeAdminLegend:
        "All fields should be enabled and this group has permission to modify all vessels.",
      customLegend: `This group does not exist by default. The name "Custom" appears in this field only when the admin selects a different pattern than the ones we have for any user.`,
      viewerLegend:
        "This group will have the ability to view the entire application but will not be able to edit or create any CTO, permissions, or other resources within the Reef.",
    },

    permissionForm: {
      userGroup: "User group",

      //WO
      changeWoStatus: "Change WO status",

      //SUPPORT REQUEST
      managerRequest: "Manage request",

      //USE PERMISSION
      changeUserPermission: "Change other user's permissions",

      //CTO GROUPING
      groupCto: "Group CTO",

      //CTO
      ctoIdentification: "Identification",
      ctoInitiation: "1. Initiation",
      ctoEvaluation: "2. Evaluation and Risk Assessment",
      ctoReview: "3. Review",
      ctoApproval: "4. Approval",
      ctoMitigation: "5. Mitigation Action Implementation",
      ctoReassessment: "6. Re-assessment For Closure",
      ctoClosureVerification: "7. Closure Verification",
      ctoClosureApproval: "8. Closure Approval",
      extendDate: "Extend CTO Period",
      cancelCto: "Cancel CTO",
    },

    // New CTO Permissions form
    permissionFormNewCto: {
      ctoIdentification: "Identification",
      ctoInitiation: "1. Initiation",
      ctoEvaluation: "2. Evaluation and Risk Assessment",
      ctoReviewAndApproval: "3. Review & Approval",
      ctoRecommendations: "4. Mitigation Action Implementation",
      ctoReassessment: "5. Re-assessment for Closure",
      ctoVerificationAndClosure: "6. Closure Verification & Approval",
    },

    userPermission: {
      title: "User Permission",
      groupManagementButton: "User Group Management",
      newUser: "New user",
      editUser: "Editing user permission",
      addPermission: "Add More Permission",

      shapeAdmin: "Shape's Admin",
      vesselAdmin: "Vessel Admin",
      processSafetyLead: "Process Safety Lead",
      opsManager: "Ops. Manager",
      custom: "Custom",
      viewer: "Viewer",

      deleteUserTitle: "Delete user permission",
      deleteUserGroup:
        "Are you sure you want to delete permission {{group}} for user {{email}}?",
      deleteUser:
        "You are deleting all user groups and permissions for user {{email}}. Are you sure you want to proceed with the deletion?",
      deletePermission: "Delete this permission",
      noPermissionToEdit: "No permission to edit",
      noPermissionMessage:
        "You currently have no permission to edit this step. Please request access to the Vessel's Administrator.",
      permissionHistory: "Permission history",
      userCreateBy: "User created by {{email}} on {{date}}",
      permissionChangedBy: "Permission changed by {{email}} on {{date}}",

      createPosition: 'Create position "{{name}}"',
      positionsLoadError:
        "Could not load the position list. Close and reopen to try again.",
      positionCreateError:
        "Could not create the position. Select an existing one or try again.",
      profileSavedPermissionsFailed:
        "Name and position were saved, but the permissions were not. Please try saving the permissions again.",
    },

    tagGroup: {},

    sceGroup: {
      sceTitle: "SCE: {{sceCode}} {{sceName}}",
    },

    /// ////////////////////////////////////////////////////////////////////////////
    ///                                                                         ///
    ///   PAGES                                                                 ///
    ///                                                                         ///
    /// ////////////////////////////////////////////////////////////////////////////

    homePage: {
      chooseYourRegion: "Choose your region",
    },

    bowtiePage: {
      taskBarModal: {
        downloadTheSelectedBowtie: "Download the selected Bowtie",
        searchForSpecific: "Search for a specific SCE or barrier",
        zoomInOrUseTheMouse: "Zoom in or use the mouse wheel",
        zoomTheBowtie: "Click here to zoom in the bowtie",
        howToNavigate: "How to navigate?",
        taskBar: "TaskBar Modal",
        seeTheWhole: "see the whole Bowtie in the screen",
      },
      riskLevelIndicator: {
        title: "Event Likelihood",
        veryHigh: "Very High",
        high: "High",
        medium: "Medium",
        low: "Low",
        veryLow: "Very Low",
        barrierCategoryTitle: "Barrier Categories",
        barrierCritical: "Critical",
        barrierDegraded: "Degraded",
        barrierHealthy: "Healthy",
        tooltipVeryHigh: "Almost Certain",
        tooltipHigh: "Likely",
        tooltipMedium: "Possible",
        tooltipLow: "Unlikely",
        tooltipVeryLow: "Rare",
        footer: "Click to filter by Likelihood",
      },
      downloadModal: {
        selectATypeToDownload: "What will be the Bowtie format?",
        whiteBackground: "White Background",
        blackBackground: "Black Background",
        transparentBackground: "Transparent Background",
        downloadModal: "Download Modal",
      },
      helpModal: {
        title: "How to read the Bowtie?",
        bowtieDiagrams: "Bow tie diagrams",
        bowtieDiagramsDescription:
          "Bow-tie diagrams of Major Accident Hazards (MAHs) present the links between top events, their threats and potential consequences, highlighting the barriers in place to prevent their occurrence and to reduce their impact on the safety of personnel and the environment.  Bow-tie diagrams play an important role in the management of MAHs by clearly communicating the strategy in place to prevent the occurrence of MAH events, and to recover from such occurrences with minimal risk of loss of life or damage to the environment",
        topEvents: "Top events",
        topEventsDescription:
          "Top events are a manifestation of a Major Accident Hazard (MAH) into a dangerous situation, which could lead to terrible consequences if not properly mitigated.\n\ne.g. loss of containment may be a top event caused from the fact that the FPSO operation involves flammable hydrocarbon storage (a hazard on itself, considered a Major Accident Hazard, MAH).",
        threats: "Threats",
        threatsDescription:
          "Threats are external phenomena which always have a certain likelihood or rate, and which can cause the manifestation of the MAH into a top event.\n\ne.g. corrosion is a threat to loss of containment top events, because corrosion is a phenomenon which might lead to a breach in hydrocarbon containment equipment.",
        consequences: "Consequences",
        consequencesDescription:
          "Consequences are the upmost events MODEC is trying to avoid which may result from a top event incident.\n\ne.g. fatalities and personnel entrapment due to fire and explosion may be a consequence from the escalation of loss of containment events.",
        barriersDescription:
          "Barriers are the safeguards we have in place to control and minimize threats, reducing our chance of having a top event, as well as to mitigate the effects of top events if they occur so that we don’t reach the consequences. Barriers can be groups of Safety Critical Elements (SCEs). Safety-critical-elements can be either equipment, systems, or procedures which have a safety function.",
        escalationFactors: "Escalation factors",
        escalationFactorsDescription:
          "Escalation factors are scenarios which could lead to the impairment of the barrier to which they are attached. Safeguards are in place (barriers) to prevent escalation factor to happen.\n\ne.g. escape route critical is an escalation factor of the Escape to TR barrier, because it depicts the unavailability of the Escape to TR barrier, and, therefore, its inability to fulfill its safety function. Barriers such as Alternative Escape Routes are in place so that the safety function can still be fulfilled.",
        bowtieElementsStatusLogic: "Bowtie elements status logic",
        bowtieElementsStatusLogicDescription:
          "The category represents the risk frequency band. It is precisely the qualitative reading of the number: VH ≈ once a year, H ≈ 1 in 100 years, M ≈ 1 in 10,000 years, L ≈ 1 in 10 million, VL ≈ practically never. Changing category means changing order of magnitude. So H is always worse than M, always — the category is orderable, and it is what carries the 'how often'. The percentage does not tell you 'how much risk'; it only tells you where within the band that value fell. H 55% and M 95% are both in the same frequency band (~1 in 100 years); the 55% simply signals that the value sits close to the boundary with the neighbouring category, while the 95% means it sits in the middle of it. An M on a multiple-fatality consequence may demand more action than an H on a minor-harm consequence. The platform shows the category, which is the 'how often' axis, while the event it is tied to is the 'how severe' axis.",
      },
    },

    mahPage: {
      selectMAHToSeeItsBarriers: "Select a MAH to see its Barriers",
      selectMAHToSeeItsSCEs: "Select a MAH to see its SCEs",
      criticalMahAlert: "There is one or more critical TAG for this MAH",
      criticalMahMessage: "There is one MAH affected for this SCE",
      topEvent: "Top Event",
      hazard: "Hazard",
      showMore: "Show more SCEs",
      showLess: "Show less",
    },
    hcPage: {
      selectHcToSeeItsSCEs: "Select a HC to see its SCEs",
      criticalHcAlert: "There is one or more critical TAG for this HC",
      criticalHcMessage: "There is one HC affected for this SCE",
      topEvent: "Top Event",
      hazard: "Hazard",
    },

    tagsPage: {
      currentStep: "CTO Step",
      tagWo: "TAG/WO VIEW",
      openWo: "Open WO",
      redundant: "Redundant TAGs",
      refDrawing: "Ref. Drawing",
      noOpenedWo: "No opened WO",
      tagTitle: "TAGs - {{country}} - {{vesselId}}",
      tagsBySce: "TAGs by SCE {{sceCode}}",
      tagType: "TAG Type",
      reason: "Reason",
      sensor: "Sensor",
      deferment: "Deferment",
      wo: "Work Order",
      woTitle: "Work Orders for {{tagCode}}",
      noWorkOrders: "No Work Orders Found",
      woLate: "late",
      woOnTime: "on time",
      sensorCritical: "Inhibited for more than 72 hours",
      sensorDegraded: "Inhibited for less than 72 hours",
      sensorHealthy: "Not Inhibited",
      noSensorDetected: "No sensor detected",
      mahsAndBarriers: "MAHs - Barriers",
      hcsAndBarriers: "HCs - Barriers",
      mahsAndBarriersModalTitle: "Linked MAHs and Barriers",
      hcsAndBarriersModalTitle: "Linked HCs and Barriers",
    },

    supportRequestModal: {
      replyingTo: "Replying to",
      selectCategory: "Select a category...*",
      needHelp:
        "Need help with the system? Open a request for issues related to data, process, bugs or any feedback.",
      addSupportRequest: "Add Support Request",
      writeReportTitle: "Write your request title...*",
      writeReportRequest: "Write your support request...*",
      writeReply: "Write your reply...*",
      closeAndArchive: "Close and archive request upon reply",
      attachFile: "Attach file",
      attachedFile: "Attached file",
    },

    helpDeskModal: {
      title: "Help Desk",
      subtitle:
        "Need help with the system? Open a ticket for issues related to data, process, bugs or any feedback.",
      createTicket: "Create new ticket",
      createTicketDescription:
        "Report a bug, request a feature or ask for support.",
      viewTickets: "View my tickets",
      viewTicketsDescription:
        "Track the status and replies of tickets you have opened.",
      opensInNewTab: "Opens in a new tab",
    },

    supportRequestPage: {
      title: "Support Requests",
      addButton: "Add Support Request",
      confirmCloseModal: {
        title: "Close and archive request",
        content: "Are you sure you want to close and archive {{requestId}}?",
        closing: "Closing...",
      },
    },

    workOrderPage: {
      wosFor: "WOs for {{selectedTag}}",
      wonosPriorityManuallyAltered:
        "This Work Order priority has been manually altered.",
      executeDate: "Execute Date",
      maintClass: "Maint Class",
      seeFullInfo: "SEE FULL WO INFO",
      selectATagToSeeItsWos: "Select a TAG to see its WOs",
      effect: "Effect",
      priority: "Priority",
    },

    scesPage: {
      seeTags: "See TAGs",
      NumberOfTAGs: "Nº of TAGs",
    },

    ctoPage: {
      ctoList: "CTO LIST",
      ctoTitle: "Title",
      ctoSummary: "CTO Summary",
      openCTOs: "Open CTOs",
      ctoHistoryLog: "CTO History Log",

      initiatedBy: "Initiated by",
      linkedSce: "Linked SCEs",
      linkedSceEps: "Linked Barriers",
      requestorInfo: "REQUESTOR INFO",

      reject: "Version {{version}} ",
      current: "Current Version",
      history: "History:",
      currentStep: "Current Step",

      initiationDate: "Initiation Date",
      expirationDate: "Expiration Date",
      finalDate: "Final Date",
      finalDateTooltip: {
        planned: "This date corresponds to the planned final date for this CTO",
        actual: "This date corresponds to the actual final date for this CTO",
      },

      dateOfAssessment: "Date of assessment",
      ctoExpiry: "CTO Expiry Date",
      newExpiryDate: "New expiry date",
      actionDueDate: "Actions Due Date",
      dateHistory: {
        buttonTitle: "Date History",
        modal: {
          CTOTitle: "CTO Date History",
          dateAndTime: "Date and time",
          justification: "Justification",
          recommendationTitle: "Recommendation Date History",
          username: "Username",
        },
      },

      criteria: "Criteria",
      relevantMAHsAffected: "Relevant MAHs affected",
      implementationZero: "Implementation 0",
      filledBy: "Filled by",

      changeWoPriority: "Change Work Order Priority",
      changePriorityWo: "Change WO priority ",

      possibleRecommendations: "Possible recommendations",

      verificationMitigations: "Verifications on the mitigations ",

      tagStatusUpdate:
        "Due to CTO activities, TAG's status is will be soon updated.",

      ctoExportPDF: "Download the CTO's current version in PDF.",

      riskMatrix: {
        additionalMitigation:
          "Must this additional mitigation be completed before CTO process is approved for use?",
        potentialConsequences:
          "Are the potential consequences changed by additional recommendations?",
        permanentChange: "Is the recommendation permanent change?",
        recommendationDue: "Recommendation Due Date",
        allActionee: "All actionee-related fields are required",
        attachedFilesReferenceDocuments:
          "MAH case; Information of design; Inspection records; Pictures if available",
        uploadReferenceDocument: "Upload reference document (optional)",
        deleteFileSuccess: "File successfully deleted!",
        initialRiskLevel: "Initial risk level",
        residualRiskLevel: "Residual risk level",
        seeRiskMatrix: "See Risk Matrix",
        matrix: "5x5 Risk Matrix",

        riskAssessment: "Risk assessment",
        riskAssessmentAfterMeasures:
          "Risk assessment after contingency plan and recommendations",
        manage: "manage for continued improvement.",
        shall:
          "shall identify additional controls and recovery measures and implement based on hierarchy controls.",
        identify:
          "identify additional controls and recovery measures and implement so that risk has been reduced to the lowest level that is reasonably practical.",
        recommendationDueDate:
          "Recommendation due date must be no later than CTO expiry date",
      },

      ctoHistory: {
        historyLog: "History Log",
        changes: "CHANGES:",
        from: "From:",
        to: "To:",
      },
    },

    ctoGroupingDecision: {
      intro:
        "There are existing active CTOs belonging to this SCE, you can group this TAG with an existing CTO from this list:",
      sourceSummary:
        "There are existing active CTOs for this SCE. Review the list below to decide whether this TAG should join an existing CTO or start a new one.",
      emptyMessage: "No eligible CTOs were returned for this decision.",
      errorMessage:
        "We could not load grouping options right now. Please try again.",
      permissionMessage:
        "You can review this decision, but you dont have permission to submit an action.",
      actionError:
        "We could not complete your decision right now. Please try again.",
      footerNote:
        "Grouping keeps the history unified and prevents reopening the evaluation.",
      createNewCto: "Create New CTO",
      addToSelection: "Add to Selection",
      creating: "Creating...",
      adding: "Adding...",
      optionDescription:
        "{{tags}} - Initiated on {{initiatedAt}} - Due date {{dueDate}}",
    },

    dashboardPage: {
      ctoList: "CTO List",
      list: "List",
      status: "Status",
      openRecommendationStatus: "Open Recommendation Status",
      recommendationStatus: "Recommendation Status",
      recommendations: "Recommendations",
      recommendationsTab: {
        ctoStatus: "CTO Status",
        controlStatus: "Control Status",
        recommendation: "Recommendation",
        actionee: "Actionee",
        dueDate: "Rec. Due Date",
      },
    },

    contingencyPlan: {
      label: "Contingency Plan",
      labelEps: "Contingency Plan?",
      contingencyPlanWithColon: "Contingency Plan:",
      typeContingencyPlan: "Type Contingency Plan",
      selectFromExisting: "Select from existing option",
      selectExisting: "Select existing contingency plan",
      manageContingencyPlan: "Manage Contingency Plan",
      newContingencyPlan: "New Contingency Plan",
      deleteContingencyPlan: "Delete Contingency Plan",
      editingContingencyPlan:
        "Editing Contingency Plan {{contingencyPlanCode}}",
      deleteMassage:
        "You are deleting the {{contingencyPlanCode}}. Are you sure you want to proceed with the deletion?",
      editingTooltip:
        "With this edition, all CTOs already using this Contingency Plan will change.",
    },

    createCto: {
      newCto: "New CTO",
      criticalSceTag: "Critical SCE (equipments) TAG(s)",
      defermentCto: "CTO de Deferment",
      oatsWorkOrder: "OATS",
      overdue: "Overdue",
      criticalSceTagEps: "Criticality 1 - CSG TAGs",
      theCTOWillBeOpenToAllTags:
        "This TAG belongs to a family (The CtO will be open to all the TAGs that belongs to family):",
      thereIsAlreadyCtOProcessOpen:
        "There is already a CtO process open for this TAG. The same TAG cannot have more than one open CtO.",
      clickHereToSeeCto: "Click here to see ongoing CtO",
      successCreate: "Success! {{cto}} created",
      tagStatusUpdate:
        "Please, note that related TAGs status will be updated in a few minutes.",
    },

    stepsTitles: {
      initiation: "1. CTO Initiation",
      evaluation: "2. CTO Evaluation & Risk Assessment",
      review: "3. CTO Review",
      reviewEps: "CTO Review & Approval",
      approval: "4. CTO Approval",
      recommendations: "5. Mitigation Action Implementation",
      reassessment: "6. CTO Re-Assessment for closure",
      reassessmentEps: "6. CLOSURE VERIFICATION & APPROVAL",
      verification: "7. Closure verification",
      closure: "8. Closure Approval",
    },

    newStepsTitles: {
      initiation: "1. CTO Initiation",
      evaluation: "2. CTO Evaluation & Risk Assessment",
      review: "3. CTO Review & Approval",
      reviewEps: "CTO Review & Approval",
      recommendation: "4. Mitigation Action Implementation",
      reassessment: "5. CTO Re-Assessment for closure",
      closure: "6. Closure verification & Approval",
    },

    newStepsNames: {
      initiation: "CTO Initiation",
      evaluation: "CTO Evaluation & Risk Assessment",
      review: "CTO Review & Approval",
      recommendation: "Mitigation Action Implementation",
      recommendationEps: "Closure Verification & Approval",
      reassessment: "CTO Re-Assessment for closure",
      closure: "Closure verification & Approval",
    },

    rejectedStepInfo: {
      from: "Rejected by {{author}}",
      to: "Rejected on Step {{step}}",
    },

    stepsInfos: {
      initiation:
        "The CtO has been identified as necessary. In this step, the OIM (or delegated users) is required to report the conditions that led to the need for the CtO, identifying the critical element's current state and forming an assessment team.",
      evaluation:
        "In this step, the CtO is in the evaluation and risk assessment phase, which should be carried out by the Assessment Team, led by the designated Process Safety Engineer. The assessment team should complete a contingency plan if necessary, inputting the risk level and providing all recommendations to address the issue.",
      review: `In this step, the Process Safety Lead/Technical Expert is required to review the CtO, providing feedback on the adequacy of the information regarding the original operating condition and immediate impact.
        <br><br><strong>Users who have successfully completed step 2. CtO Evaluation & Risk Assessment are not allowed from filling out this particular step, regardless of their permissions.</strong>`,
      approval: `In this step, the Operations Manager is required to approve the CtO, confirming if the risk level is adequately managed and defining an expiry date.
        <br><br><strong>Users who have successfully completed step 2. CtO Evaluation & Risk Assessment or step  3. CTO Review are not allowed from filling out this particular step, regardless of their permissions.</strong>`,
      recommendations:
        "In this step, the OIM, actionees, or delegated users must ensure the implementation of any identified risk mitigation measures listed in the CtO. They should provide information on all actions taken to fulfill the recommendations set by the risk assessment team.",
      reassessment: `In this step, the OIM or delegated user should confirm whether the impaired SCE has returned to its original state.
        <br><br><strong>Users who have successfully completed step 5. Mitigation Action Implementation are not
allowed from filling out this particular step, regardless of their permissions</strong>`,
      verification: `In this step, the Process Safety Lead/Technical Expert verifies that the SCE has been rectified, abnormal conditions have been eliminated, or a permanent solution has been implemented (via Management of Change), and the facility has been returned to its original state, allowing for the closure of the CtO.
        <br><br><strong>Users who have successfully completed step 5. Mitigation Action Implementation or step
6. CTO Re-Assessment for Closure are not allowed from filling out this particular step, 
regardless of their permissions.</strong>`,
      closure: `In this step, the Operations Manager is required to approve the closure of the CtO.
        <br><br><strong>Users who have successfully completed step 5. Mitigation Action Implementation, step 6. CTO
Re-Assessment for Closure or step 7. Closure Verification are not allowed from filling out this
particular step, regardless of their permissions</strong>.`,
    },

    newStepsInfos: {
      initiation:
        "The CtO has been identified as necessary. In this step, the OIM (or delegated users) is required to report the conditions that led to the need for the CtO, identifying the critical element's current state and forming an assessment team.",
      evaluation:
        "In this step, the CtO is in the evaluation and risk assessment phase, which should be carried out by the Assessment Team, led by the designated Process Safety Engineer. The assessment team should complete a contingency plan if necessary, inputting the risk level and providing all recommendations to address the issue.",
      review: `In this step, Asset Management Coordinator, Engineering Technical Manager and Operations Manager are required to review and approve the CtO, providing feedback on the adequacy of the information regarding the original operating condition and immediate impact and confirming if the risk level is adequately managed and defining an expiry date.
        <br><br><strong>Users who have successfully completed step 2. CtO Evaluation & Risk Assessment are not allowed from filling out this particular step, regardless of their permissions.</strong>`,
      recommendation:
        "In this step, the OIM, actionees, or delegated users must ensure the implementation of any identified risk mitigation measures listed in the CtO. They should provide information on all actions taken to fulfill the recommendations set by the risk assessment team.",
      reassessment: `In this step, the OIM, Process Safety Engineer or delegated user should confirm whether the impaired SCE has returned to its original state.
        <br><br><strong>Users who have successfully completed step 4. Mitigation Action Implementation are not allowed from filling out this particular step, regardless of their permissions.</strong>
        <br><br>If the CTO deadline has passed and the SCE/CSG critical failure or abnormal condition has not been rectified, returned to its original state, or had a permanent solution implemented (via MoC), the user can return to step 2, where the Operations Manager or Process Safety Engineer has the capability to extend the expiry date by another 30 days, up to a maximum period of 90 days.`,
      closure: `In this step, the Asset Management Coordinator, Engineering Technical Manager and Operations Manager verifies that the SCE has been rectified, abnormal conditions have been eliminated, or a permanent solution has been implemented (via Management of Change), and the facility has been returned to its original state, allowing for the closure of the CtO.
        <br><br><strong>Users who have successfully completed step 4. Mitigation Action Implementation or step 5. CTO Re-Assessment for Closure are not allowed from filling out this particular step, regardless of their permissions.</strong>`,
    },

    stepBlockInfo: {
      review:
        "You cannot advance to this step as you have completed step 2; therefore, the same user cannot complete both steps.",
      approval:
        "You cannot advance to this step as you have completed steps 2 or 3; therefore, the same user cannot complete both steps.",
      recommendation:
        "You cannot advance to this step as you have completed steps 2 or 3; therefore, the same user cannot complete both steps.",
      reassessment:
        "You cannot advance to this step as you have completed step 5; therefore, the same user cannot complete both steps.",
      verification:
        "You cannot advance to this step as you have completed steps 5 or 6; therefore, the same user cannot complete both steps.",
      closure:
        "You cannot advance to this step as you have completed steps 5, 6, or 7; therefore, the same user cannot complete both steps.",
    },

    newCtoStep0: {
      currentStep: "Step 0 - Triage",
    },

    newCtoStep1: {
      initiationDetails: "Initiation Details",
      whatIsTheConditionFound:
        "What is the SCE critical failure/ abnormal condition?",
      whatIsTheConditionFoundCSg:
        "What is the Criticality 1 - CSG failure/ abnormal condition?",
      wereTheProposedMitigationsImplemented: "Mitigations Implemented",
      ctoTitle: "CTO Title",
      equipment: "Equipment",
      performanceStandards: "Performance Standards",
      requestorInfo: "Requestor Info",
      currentStep: "Step 1- CTO Initiation",
      operationalSafetyDeclaration:
        "I declare that I have read the information presented and confirm that it is safe to operate in the next 72 hours with the indicated mitigations.",
      oimAccountabilityDeclaration: "OIM declaration",
      operationsManagerAccountabilityDeclaration:
        "Operations Manager declaration",
      barrierTriage: {
        question: "Does this Tag impact the barrier safety function?",
        yesOption: "Yes — this TAG affects the barrier safety function.",
        noOption: "No — this TAG does not affect the barrier safety function.",
        justificationLabel: "Justification",
        justificationPlaceholder:
          "Explain why this TAG does or does not affect the barrier safety function",
        firstRespondentYesBanner:
          "TAG {{tagCode}} was classified as an impact for the safety barrier. Creating this CTO, please fill in the information needed to advance this CTO.",
        secondRespondentBanner:
          "TAG {{tagCode}} was classified as NOT an impact for the safety barrier, making this CTO not needed, please review the information and confirm or deny the statement.",
        reassessAccountabilityBanner:
          "{{tagCode}} was added to this CTO - review required. Check if the barrier condition still applies to the new TAG. Any changes you save will create a new version of this CTO without overwriting the previous assessment.",
        marked: "Marked",
      },
    },

    ctoStep1: {
      performanceStandards: "PERFORMANCE STANDARDS",
      performanceStandardsCriteria:
        "Applicable SCE Performance Standard Criteria",
      performanceStandardsCriteriaEps:
        "Applicable Criticality 1 - CSG Performance Standard Criteria",
      expectedFunction:
        "Critical SCE’s expected function under normal conditions:",
      expectedFunctionEps:
        "Criticality 1 - CSG expected function under normal conditions:",
      possibleToManagerConditions:
        "Is it possible to manage the SCE critical failure/abnormal condition by existing procedures? Please attach evidence of managing abnormal conditions.",
      possibleToManagerConditionsEps:
        "Is it possible to manage Criticality 1 - CSG impairment by existing procedures? Please attach evidence of managing abnormal conditions",
      initiationDetails: "INITIATION DETAILS",
      ctoAutomaticallyInitiated: "CtO automatically initiated due critical TAG",
      caseToOperateType: "Case to Operate Type",

      equipment: "EQUIPMENT",
      sisModificationQuestion:
        "Hardware/Software/Firmware modification/revision/update for a Safety Instrumented Systems (SIS) or for SIS interface related - Basic Process Control System (BPCS) / Human-Machine Interface (HMI) / Motor Control Center (MCC) / Alarm",
      notRequired: "Not Required",
      howWasTheConditionFound:
        "How was the SCE impairment / abnormal condition found ?",
      howWasTheConditionFoundEps:
        "Is it possible to manage CSG impairment by existing procedures? Please attach evidence of managing abnormal conditions",
      criticalSceTag: "Critical SCE (Equipment) TAG(s)",
      criticalSceTagEps: "Critical CSG (Equipment) TAG(s)",
      overdueWorkOrder: "Overdue Work Order",
      overdueWorkOrders: "Overdue Work Orders",
      addMoreMember: "ADD MORE TEAM MEMBER",
      youCanAddMoreMembers: "You can add more members with different roles.",
      assessmentTeamMembers: "Create Assessment Team",
      operationalEngineer: "Operational Engineer",
      hseRepresentative: "HSE Representative",
      relevantSuperintendent: "Relevant Superintendent",
      riskAssessmentFacility: "Risk assessment leader",
      facilitator: "Facilitator",
      safeToOperateShortDuration:
        "Safe to Operate for short duration (72hrs) until CtO evaluation & risk assessment process complete?",
      oimIsDirectedToDiscuss:
        "The OIM is directed to discuss the CtO with the Operations Manager and decide whether it is safe or not to continue operations. This Case to Operate form has been saved, please return once OIM completes discussion with operations manager.",
      automatic: "Automatic",
      manual: "Manual",
      currentStep: "Step 1- CTO Initiation",
      isThereAnyExistingCTO:
        "Is there any existing CTO relevant to this identified SCE impairment/abnormal conditions?",
      mocStatus: "MOC Status:",
      mocNumbers: "MOC Number(s)",
      mocMessage:
        "Hovering over the MOC IDs enables the visualization of status.",
      justification: "Justification",
      uploadAndAttachFiles: "Upload and attach files",
      ctoSummary: "CTO Summary",
      implementedActionsDescription: "Description of implemented actions",
      mitigationProtocol: {
        sceBarrier: "SCE Barrier affected",
        title: "Mitigation",
        alert:
          "This tag already has a predefined Mitigation Protocol. Please select the scenario that best matches the situation and confirm the use of this protocol, the chosen actions will be set as recommendations further in the CTO. If you prefer not to use it, you can reject it below.",
        details: {
          button: "Protocol Details",
          title: "Mitigation Protocol",
          messages: {
            first:
              "Initial decision to stop or restrict operation may be necessary if operational safety is threatened.",
            second:
              "Investigation team should confirm the impairment of the SCE tag impairment and need for a Mitigation Protocol within 12 hours.",
            third:
              "On confirmation of the impairment, the Mitigation Protocol should be executed by offshore team immediately to avoid exposure to increase in risk.",
            fourth:
              "OIM (or delegate) will re-validate this protocol every seven days.",
          },
        },
        noProtocolApplicable: "No Protocol Applicable",
        useThisProtocol: "Use Selected Protocol",
      },
    },

    ctoStep2: {
      ctoEvaluationAndRisk: "CTO EVALUATION & RISK ASSESSMENT",
      assigningRecommendation: "ASSIGNING RECOMMENDATION",
      diagnosis: "Diagnosis",
      riskAssessmentLeader: "Risk assessment leader",
      sceDetails: "SCE DETAILS",
      sisModificationAssessment: "SIS Modification Assessment",
      sisModificationAssessmentMandatory:
        "It's mandatory to the CTO submission that at least one of the fields below are filled",
      sceDetailsEps: "Criticality 1 - CSG Details",
      howPotentialConsequences:
        "Potential Consequences associated with the SCE and how potential consequences / frequencies are affected by the critical failure of the SCE?",
      howPotentialConsequencesEps:
        "How potential consequences / frequencies are affected by the Criticality 1 - CSG",
      isPermanentChange: "Is the recommendation a permanent change?",
      additionalMitigation:
        "Must this additional mitigation be completed before CTO process is approved for use?",
      changedByAdditionalRecommendations:
        "Are the potential consequences / frequency changed by additional recommendations?",
      actioneeNameOrEmail: "Actionee's name or e-mail",
      addNewRecommendation: "Add new recommendation",
      currentStep: "Step 2 - CTO Evaluation & Risk Assessment",
      manualOfPermittedOperations:
        "The Manual of Permitted Operations (MOPO) has been reviewed?",
      hasThisIssueBeenManaged: "Has this issue been managed in another system?",
      idOfTheIssueInOtherSystem: "ID of this issue in the other system",
      fillInformation: "Please fill the following option",
      beClosedAtEnd: "Action to be closed at the end of the CTO",
      temporaryDueDate: "Inform a temporary recommendation due date",
      approveInfoTitle: "Is the information provided on Step 1 approved?",
      processSafetyApproveInfoTitle:
        "Approve the information provided in this step?",
      processSafetyComplement: "Process Safety complement",
      processSafetyMoreInformationRequired:
        "More information required by Process Safety",
      initialRiskLevel: "Initial Risk Level",
      residualRiskLevel: "Residual Risk Level",
      returnToStep1: "Return to Step 1",
      requestRevision: "Request revision",
      moreInformationRequired: "More information required",
      affectedAreas: {
        title: "Affected areas",
        instructionPrefix: "Identify the areas that are affected by the",
        instruction:
          "Identify the areas that are affected by the TAG: {{tagCode}}",
        readOnlyInstruction: "Affected areas selected for TAG: {{tagCode}}",
        noOptions: "There are no affected-area options available for this TAG.",
        loading: "Loading affected areas...",
        loadError: "Could not load affected areas. Please try again.",
        retry: "Retry",
        required:
          "Select at least one affected area for each TAG with available options.",
        barrier: "Barrier",
        causeOrConsequence: "Cause / consequence",
      },
      externalElementImpact: {
        title: "CSG impact",
        question: "Is a CSG impacted?",
        required:
          "Answer whether a CSG is impacted before submitting.",
      },
    },

    newCtoStep2: {
      currentStep: "Step 2 - CTO Evaluation & Risk Assessment",
    },

    ctoStep3: {
      currentStep: "Step 3 - CTO Review",
      recommendationCompleted:
        "Are the recommendations required before approval completed?",
      identifyOriginalOperating:
        "Does CTO clearly identify original operating conditions, impairment, reason, immediate impact and status?",
      alert:
        "All recommendations specified in Step 2 must be completed. If this recommendation is not yet completed, you will not be able to submit this form.",
    },

    newCtoStep3: {
      approveInfoTitle: "Approve the information provided in this step?",
      returnToStep2: "Return to Step 2",
      currentStep: "Step 3 - CTO Review & Approval",
    },

    ctoStep4: {
      currentStep: "Step 4 - CTO Approval",
      contingencyPlanImplemented:
        "Has the contingency plan mitigations been implemented?",
      riskLevel: "Is the residual risk considered acceptable (i.e. ALARP)?",
    },

    newCtoStep4: {
      hasActionToBeClosed: "Action to be closed at the end of CTO",
      temporaryDueDate: "Reversion Due Date",
      requestExtension:
        "The expiry date has passed. Please request an extension for this Recommendation",
      extendExecutionDueDate: "Extend Execution Due Date",
      extendRecommendationDueDate: "Extend Recommendation Due Date",
      recommendations: "Recommendation",
      currentlyEditing: "Currently editing Step 4",
      isTemporaryReversed: "Is the temporary recommendation removed?",
      currentStep: "Step 4 - Mitigation Action Implementation",
    },

    ctoStep5: {
      recommendations: "Recommendations",
      mitigationAction: "Mitigation action implementation",
      recommendationDetails: "Recommendation Details",
      moc: "MOC Number",
      implActions: "Implementation Actions",
      nexStepAutomatically:
        "Once all recommendations are confirmed, the CTO moves on to the next step automatically.",
      currentStep: "Step 5 - Mitigation Action Implementation",
      actioneeRegistered: "Actionee registered in Step 2",
      currentlyEditing: "Currently editing Step 5",
      alert:
        "All recommendations specified in Step 2 must be completed.  If this recommendation is not yet completed, you will not be able to submit this form.",
    },

    newCtoStep5: {
      areThePermanentMitigation:
        "Are the permanent mitigation measures completed and closed?",
      currentStep: "Step 5 - CTO Re-Assessment for closure",
    },

    ctoStep6: {
      areThePermanentMitigation:
        "Are the permanent mitigation measures in MoC process completed and closed?",
      recommendationToActionee: "Recommendation to actionee",
      recommendationEvaluation: "Recommendation evaluation",
      temporaryMitigationRemoved:
        "Are the temporary mitigation measures removed?",
      backToOriginalState:
        "Is the critical SCE (equipments) TAG(s) back to original state?",
      backToOriginalStateEps:
        "Is the critical Criticality 1 - CSG TAG(s) back to original state?",
      currentStep: "Step 6 - CTO Re-Assessment for closure",
    },

    newCtoStep6: {
      step4Label: "4 - Mitigation Action Implementation",
      step5Label: "5 - CtO Re-assessment for Closure",
      closureJustification: "Justification",
      approveInfoTitle: "Approve the information provided in this step",
      whichStepGoBack: "Which step CtO must go back?",
      closureClosed: "CTO is approved for closure?",
      reassessmentInformation:
        "Is the CTO re-assessment information provided acceptable to proceed for CTO closure?",
      returnToStep4: "Return to Step 4",
      returnToStep5: "Return to Step 5",
      currentStep: "Step 6 - Closure verification & Approval",
    },

    ctoStep7: {
      closureVerification: "Closure Verification",
      reassessmentInformation:
        "Is the CTO re-assessment information provided acceptable to proceed for CTO closure?",
      whichStepGoBack: "Which step CtO must go back?",
      step5Label: "5 - CtO Mitigation Action Implementation",
      step6Label: "6 - CtO re-assessment for closure",
      step7Label: "7 - CtO Closure verification",
      currentStep: "Step 7 - Closure verification",
    },

    ctoStep8: {
      closureApproval: "Closure Approval",
      closureClosed: "CTO is approved for closure?",
      woClosedInCMMS: "Are the WOs that generate the CtO closed in CMMS?",
      ctoCanNotBeClosed:
        "CtO can not be closed until the work orders are also closed",
      currentStep: "Step 8 - Closure Approval",
    },

    cancelCto: {
      cancelCto: "Cancel CTO",
      manualCancellation: "Manual cancellation",
      reasonForCancellation: "Reason for cancellation:",
      successCancelledCto:
        "CTO has been successfully cancelled and its information will be available for future visualization only",
      ctoIsNoLongerNecessary:
        "The WOs resulting in this CTO are no longer critical, therefore, a CtO is no longer necessary for this TAG.",
      clickHereToCancelCto: "Click here to cancel CTO",
      closeCtoInStep8:
        "The WOs resulting in this CTO are no longer critical, please proceed to confirm and close step 8 down below.",
      closedBeforeCompletion:
        "At the time this CtO was cancelled, none of the steps were filled out properly.",
      cancellationReason: "Cancellation reason:",
    },

    extendCto: {
      extendDate: "Extend date",
      editExtend: "Edit extension period",
      extendedBy: "Extension period requested by:",
      underExtension: "CTO Under extension period",
      ctoReference:
        "This CTO expired on {{date}} and can only be used for data reference.",
      initiatedBy: "Initiated by:",
      currentExpireDate: "Current due date:",
      dateHasPassed:
        "The expiry date has passed. Please, request an extension for this CtO.",
      actionNeeded: "Action needed for this CTO:",
      justificationCharactersLeft: "{{remainingChars}} characters remaining",
      currentStep: "Go on with current Step",
      backToStep2: "Go back to Step 2",
      timesExtended: "Extensions so far",
      initiatedAt: "Initiation date",
      justificationPlaceholder:
        "Describe the reason for extending this {{type}}. Include context about delays, dependencies, or relevant communications.",
    },

    extendDueDate: {
      title: "Extend Recommendation Date",
      currentImplementationDueDate: "Current Implementation Due Date",
      newImplementationDueDate: "New Implementation Due Date",
      currentReversionDueDate: "Current Reversion Due Date",
      newReversionDueDate: "New Reversion Due Date",
      reversionDueDateMustBeAfterImplementation:
        "Reversion due date must be the same day or later than implementation due date.",
      extendTemporaryDueDateDescription:
        "This Recommendation is temporary, therefore, by extending the <strong>Implementation Due Date</strong>, you need to extend the <strong>Reversion Due Date</strong> as well.",
    },

    ctoStatusAlert: {
      ctoIsExpired: "CTO is expired",
      ctoRequiresExtension: "CTO requires extension",
      warn: {
        title: "CTO Requires Extension",
        message:
          "The expiry date has passed. Please request an extension for this CTO",
      },
      error: {
        title: "CTO is cancelled",
        message:
          "The CtO was cancelled on {{date}} and can only be used for data reference.",
        observation: "Completed by: {{userEmail}}",
      },
      success: {
        title: "CTO is completed",
        message:
          "The CtO was completed on {{date}} and can only be used for data reference.",
        observation: "Completed by: {{userEmail}}",
      },
      extend: "Extend Date",
    },

    editUserModal: {
      permissions: "Permissions for",
      canEdit: "Can edit vessel(s)",
      select: "Select at least one vessel...",
    },

    eligibleUsersModal: {
      tooltip:
        "There is no user registered in the system with the necessary permissions to complete this step.",
      boxLabel: "List of users eligible to complete this step:",
      button: "View eligible users in this step",
      search: "Search",
    },

    form: {
      thisField: "This field is required",
      fieldWith: "Add comments...",
    },

    scesModal: {
      linkedSceOn: "Linked SCEs on {{data}}",
    },

    matrix: {
      matrixView: "Matrix View",
    },

    boxLabelCount: {
      pendingRemediation: "Pending Remediation Plan",
      remediationInProgress:
        "Remediation & Mitigation Implementation in Progress",
    },
  },
};
